export default __webpack_public_path__ + "static/media/mobileIcon.17cd04f1.svg";